import { freshModal } from "../freshModal";
import React, { useState } from "react";
import Modal from "./Modal";

const AdvancePaymentModalFormSession = ({
  isOpen,
  onClose,
  onSave,
  candidateId,
  hidePaymentMethod = false,
}) => {
  const [formData, setFormData] = useState({
    amount: "",
    paymentDate: new Date().toISOString().split("T")[0],
    paymentMethod: "virement",
    reason: "",
    candidateId,
    recurring: false,
    recurrenceType: "none",
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "checkbox") {
      const checked = e.target.checked;
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
        // Réinitialiser le type de récurrence si on désactive la récurrence
        ...(name === "recurring" && !checked ? { recurrenceType: "none" } : {}),
      }));
    } else if (name === "recurrenceDay" && value) {
      const numValue = parseInt(value);
      setFormData((prevData) => ({
        ...prevData,
        [name]: numValue,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Faire un acompte"
      className="max-w-xl"
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="amount"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Montant (€)
            </label>
            <input
              type="number"
              id="amount"
              name="amount"
              required
              step="0.01"
              value={formData.amount}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
          <div>
            <label
              htmlFor="paymentDate"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Date de paiement
            </label>
            <input lang="fr-FR"
              type="date"
              id="paymentDate"
              name="paymentDate"
              required
              value={formData.paymentDate}
              onChange={handleChange}
              className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        {!hidePaymentMethod && (<div>
          <label
            htmlFor="paymentMethod"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Méthode de paiement
          </label>
          <select
            id="paymentMethod"
            name="paymentMethod"
            required
            value={formData.paymentMethod}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="virement">Virement bancaire</option>
            <option value="cheque">Chèque</option>
            <option value="especes">Espèces</option>
          </select>
        </div>
        )}

        <div>
          <label
            htmlFor="reason"
            className="block text-sm font-medium text-gray-700 mb-1"
          >
            Motif de l'acompte
          </label>
          <textarea
            id="reason"
            name="reason"
            rows={3}
            value={formData.reason}
            onChange={handleChange}
            className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            placeholder="Raison de la demande d'acompte..."
          />
        </div>

        {/* Option de récurrence */}
        <div className="border-t pt-4 mt-4">
          <div className="flex items-center mb-3">
            <input
              type="checkbox"
              id="recurring"
              name="recurring"
              checked={formData.recurring}
              onChange={handleChange}
              className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
            />
            <label
              htmlFor="recurring"
              className="ml-2 block text-sm text-gray-700"
            >
              Acompte récurrent
            </label>
          </div>

          {formData.recurring && (
            <div className="bg-gray-50 p-4 rounded-md space-y-3">
              <div>
                <label
                  htmlFor="recurrenceType"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Fréquence
                </label>
                <select
                  id="recurrenceType"
                  name="recurrenceType"
                  value={formData.recurrenceType}
                  onChange={handleChange}
                  className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required={formData.recurring}
                >
                  <option value="none">Sélectionner...</option>
                  <option value="weekly">Hebdomadaire</option>
                  <option value="monthly">Mensuelle</option>
                </select>
              </div>

              {formData.recurrenceType === "weekly" && (
                <div>
                  <label
                    htmlFor="recurrenceDay"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Jour de la semaine
                  </label>
                  <select
                    id="recurrenceDay"
                    name="recurrenceDay"
                    value={formData.recurrenceDay || 1}
                    onChange={handleChange}
                    className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required={
                      formData.recurring && formData.recurrenceType === "weekly"
                    }
                  >
                    <option value="1">Lundi</option>
                    <option value="2">Mardi</option>
                    <option value="3">Mercredi</option>
                    <option value="4">Jeudi</option>
                    <option value="5">Vendredi</option>
                    <option value="6">Samedi</option>
                    <option value="0">Dimanche</option>
                  </select>
                </div>
              )}

              {formData.recurrenceType === "monthly" && (
                <div>
                  <label
                    htmlFor="recurrenceDay"
                    className="block text-sm font-medium text-gray-700 mb-1"
                  >
                    Jour du mois
                  </label>
                  <select
                    id="recurrenceDay"
                    name="recurrenceDay"
                    value={formData.recurrenceDay || 1}
                    onChange={handleChange}
                    className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required={
                      formData.recurring &&
                      formData.recurrenceType === "monthly"
                    }
                  >
                    {[...Array(31)].map((_, i) => (
                      <option key={i + 1} value={i + 1}>
                        {i + 1}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {(formData.recurrenceType === "weekly" ||
                formData.recurrenceType === "monthly") && (
                <div className="bg-blue-50 p-3 rounded-md border-l-4 border-blue-500 text-sm text-gray-600">
                  {formData.recurrenceType === "weekly" && (
                    <p>
                      Cet acompte sera versé chaque{" "}
                      {
                        [
                          "dimanche",
                          "lundi",
                          "mardi",
                          "mercredi",
                          "jeudi",
                          "vendredi",
                          "samedi",
                        ][formData.recurrenceDay || 1]
                      }{" "}
                      jusqu'à ce que vous annuliez cette configuration.
                    </p>
                  )}
                  {formData.recurrenceType === "monthly" && (
                    <p>
                      Cet acompte sera versé le {formData.recurrenceDay || 1} de
                      chaque mois jusqu'à ce que vous annuliez cette
                      configuration.
                    </p>
                  )}
                </div>
              )}
            </div>
          )}
        </div>

        <div className="flex justify-end space-x-3 pt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 bg-white hover:bg-gray-50"
          >
            Annuler
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
          >
            Valider
          </button>
        </div>
      </form>
    </Modal>
  );
};

export const AdvancePaymentModal = freshModal(AdvancePaymentModalFormSession, "isOpen");
